/**
 * Händelser mellan hjulet och den dekorerade bakgrunden, som ligger i
 * separata delar av sidan.
 */

/**
 * Halloween: dags för blixten i änkehuset. Skickas av memen i hjulets mitt
 * under första varvets sista bild, så att nedslaget kommer på utsatt tid.
 */
export const FINAL_STRIKE_EVENT = "fikahjulet:final-strike";

/**
 * Hur länge skärmen mörknar innan blixten slår ner, räknat från händelsen.
 * Samma värde som --hol-final-impact i scenes.css.
 */
export const STRIKE_BUILDUP_MS = 1200;
